import React from "react";
import { FaCheck, FaClock, FaList, FaBan, FaDollarSign } from "react-icons/fa";

const QuickFilters = ({ currentStatus, onStatusChange, counts }) => {
  const filterOptions = [
    {
      value: "on_squad",
      label: "On squad",
      icon: FaCheck,
    },
    {
      value: "waitlist",
      label: "Waitlist",
      icon: FaClock,
    },
    {
      value: "due",
      label: "Due",
      icon: FaDollarSign,
    },
    {
      value: "paid",
      label: "Paid",
      icon: FaCheck,
    },
    {
      value: "cancelled",
      label: "Cancelled",
      icon: FaBan,
    },
    {
      value: "all",
      label: "All",
      icon: FaList,
    },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {filterOptions.map((option) => {
        const isActive = currentStatus === option.value;
        const count = counts[option.value] || 0;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onStatusChange(option.value)}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm
              transition-all duration-200 border
              ${
                isActive
                  ? "bg-brand-charcoal text-brand-cream border-transparent shadow-sm"
                  : "bg-brand-cream text-brand-charcoal border-transparent hover:shadow-sm"
              }
            `}
          >
            <option.icon className="w-4 h-4" />
            <span>{option.label}</span>
            <span
              className={`
              px-2 py-1 rounded-full text-xs font-bold
              ${isActive ? "bg-white bg-opacity-20" : "bg-white bg-opacity-70"}
            `}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickFilters;
